import React from "react";
import { Typography, Paper, Box, makeStyles } from "@material-ui/core";
import Moment from "react-moment";
import Loewe from "../../assets/loewe.png";
import { grey } from "@material-ui/core/colors";
import useScreensize from "../../hooks/useScreensize";

const useStyles = makeStyles(theme => ({
  img: {
    backgroundSize: "cover",
    backgroundPosition: "center center",
    [theme.breakpoints.up("sm")]: {}
  },
  wappen: {
    backgroundSize: "90% auto",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat"
  },
  root: {
    overflow: "hidden",
    backgroundColor: grey[100]
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: "bold"
  }
}));

const StLoewe = ({ item }) => {
  const classes = useStyles();
  const { xs, sm, md, lg, xl, current } = useScreensize();

  if (!item) {
    return null;
  }

  const img =
    item.bild && item.bild.value.length ? item.bild.value[0].url : null;

  return (
    <>
      <Paper className={classes.root}>
        <Box
          display="flex"
          minHeight={220}
          flexDirection={xs ? "column" : "row"}
        >
          <Box
            width={{ xs: "100%", md: 200, lg: 140 }}
            height={{ xs: 240, sm: "auto" }}
            flexShrink={0}
            style={{ backgroundImage: "url(" + img + ")" }}
            className={classes.img}
          ></Box>
          <Box flexGrow={1} p={4}>
            <Typography variant="h4" className={classes.title}>
              {item.name.value}
            </Typography>
            <Typography variant="h4" gutterBottom>
              {item.titel.value}
            </Typography>
            <Typography variant="caption">
              ausgezeichnet im Jahr{" "}
              <Moment format="YYYY">{item.ausgezeichnet_im_jahr.value}</Moment>
            </Typography>
          </Box>
          <Box
            width={140}
            flexShrink={0}
            style={{ backgroundImage: "url(" + Loewe + ")" }}
            className={classes.wappen}
          ></Box>
        </Box>
      </Paper>
    </>
  );
};

export default StLoewe;
